import { isEmpty } from 'lodash'
import { largeSizes, legendDefault } from '.'
import { defaultExportMenu, getHorizontalGroupedSeries } from '../helpers'
export default ({ config, data, color, size = 'sm', legendLabels }) => {
  const { labelColor } = color
  const { series, disabledLegend = false, height, ...restConfig } = config
  const {
    title,
    yKey,
    scrollbar,
    scrollbarY,
    exportingMenu,
    disabledAnimations = false
  } = restConfig

  const chartConfig = {
    type: 'XYChart',
    data,
    height,
    autoDispose: true,
    scrollbarX: {
      disabled: !scrollbar,
      parent: 'bottomAxesContainer'
    },
    scrollbarY: {
      disabled: !scrollbarY,
      parent: 'rightAxesContainer'
    },
    xAxes: [
      {
        type: 'ValueAxis',
        renderer: {
          maxLabelPosition: 0.98,
          labels: {
            fill: labelColor,
            fontSize: !largeSizes.includes(size) && 10
          }
        },
        title: {
          text: title || null,
          fill: labelColor,
          fontSize: !largeSizes.includes(size) && 12
        }
      }
    ],
    yAxes: [
      {
        type: 'CategoryAxis',
        dataFields: {
          category: yKey
        },
        renderer: {
          cellStartLocation: 0.3, // columns width
          cellEndLocation: 0.7, // columns width
          grid: {
            template: {
              type: 'Grid',
              location: 0
            }
          },
          labels: {
            fill: labelColor,
            fontSize: 10
          },
          minGridDistance: 20
        }
      }
    ],
    series: getHorizontalGroupedSeries({
      series,
      otherConfig: { color, legendLabels, disabledAnimations, ...restConfig }
    }),
    legend: legendDefault(labelColor, disabledLegend)
  }

  // Export menu
  if (exportingMenu && exportingMenu.enabled) {
    if (isEmpty(exportingMenu.config)) {
      chartConfig.exporting = defaultExportMenu
    } else {
      chartConfig.exporting = exportingMenu.config
    }
  }

  return chartConfig
}
